<h2 class="page-heading">Assign Message to Group</h2>

<app-response-text [lambdaMessage]="lambdaMessage" [lambdaError]="lambdaError"></app-response-text>
<br>

<!--group filters-->
<div class="groupFilters">
  <!--hide and use activeLOB from config if not telecomAdmin-->
  <select *ngIf="isTelecom" class="custom-select spaced" [(ngModel)]="lobSelect"
    (ngModelChange)="filterGroups(lobSelect); showMessageTable = false; showGroupTable = false; groupSelect = 'DEFAULT'">
    <option class="custom-option" selected hidden ngValue="DEFAULT">Select LOB</option>
    <option class="custom-option" *ngFor="let lob of lobList" [ngValue]="lob[1]">{{lob[0]}}</option>
  </select>

  <select class="custom-select spaced" [(ngModel)]="groupSelect"
    (ngModelChange)="getGroupMessages(groupSelect); showMessageTable = false;"
    [disabled]="(lobSelect =='DEFAULT' || lobSelect == null)">
    <option class="custom-option" selected hidden ngValue="DEFAULT">Select Group</option>
    <option class="custom-option" *ngFor="let group of filteredGroups" [ngValue]="group.groupId">{{group.groupName}}
    </option>
  </select>
</div>
<br>

<div fxLayout="row" fxLayoutAlign="center" *ngIf="showGroupTable"> 
  <app-mat-data-grid 
      class="page-data-grid"
      [(dataSource)]="groupMessages"
      [formValid]="formValid" 
      [displayedColumns]="[
        'message.messageType', 'message.messageTitle', 'message.msgText.en-US', 'messageDuration.messageStartDate', 
        'messageDuration.messageStartTime', 'messageDuration.messageEndDate', 'messageDuration.messageEndTime', 'lastUpdated', 'updatedBy']"   
      [columnNames]="['Type', 'Title', 'Message', 'Start Date', 'Start Time', 'End Date', 'End Time', 'Last Updated', 'Updated By']"
      [editDefinition]="{'messageDuration.messageStartDate': startDate, 'messageDuration.messageStartTime': startTime, 'messageDuration.messageEndDate': endDate, 'messageDuration.messageEndTime': endTime}"
      [pageSizeOptions] = "[5, 10, 15]"
      [buttonConfig]="{
          create: {show: true, funcEnabled: false}
      }"
      [objectBluePrint]="{}"
      (buttonClick)="handleButtonEvent($event)">
  </app-mat-data-grid>
</div>

<ng-template #startDate let-element>
  <input type="date" 
    [(ngModel)]="element.messageDuration.messageStartDate" 
    (ngModelChange)="element.messageDuration.messageEndDate = element.messageDuration.messageStartDate; validate(element);">
</ng-template> 

<ng-template #startTime let-element>
  <input type="time" [(ngModel)]="element.messageDuration.messageStartTime" (ngModelChange)="validate(element);">
</ng-template> 

<ng-template #endDate let-element>
  <input type="date" 
    [(ngModel)]="element.messageDuration.messageEndDate" 
    (ngModelChange)="element.messageDuration.messageEndDate = element.messageDuration.messageEndDate; validate(element);">
</ng-template> 

<ng-template #endTime let-element>
  <input type="time" [(ngModel)]="element.messageDuration.messageEndTime" (ngModelChange)="validate(element);">
</ng-template> 


<div *ngIf="showMessageTable" fxLayout="row" fxLayoutAlign="center">
  <select class="custom-select table-select" [(ngModel)]="messageTypeSelect" (ngModelChange)="filterMessages()">
    <option class="custom-option" selected hidden [ngValue]="DEFAULT">Message Type</option>
    <option class="custom-option" [ngValue]="NoFilter">No Filter</option>
    <option class="custom-option" *ngFor="let type of messageTypes" [ngValue]="type">{{type}}</option>
  </select>
</div>

<div fxLayout="row" fxLayoutAlign="center" *ngIf="showMessageTable"> 
  <app-mat-data-grid 
      class="page-data-grid"
      [header]="header"
      [(dataSource)]="filteredMessages" 
      [displayedColumns]="[
        'message.messageType', 'message.messageTitle', 'message.msgText.en-US', 'messageDuration.messageStartDate', 
        'messageDuration.messageStartTime', 'messageDuration.messageEndDate', 'messageDuration.messageEndTime', 'lastUpdated', 'updatedBy']"   
      [columnNames]="['Type', 'Title', 'Message', 'Start Date', 'Start Time', 'End Date', 'End Time', 'Last Updated', 'Updated By']"
      [editDefinition]="{'messageDuration.messageStartDate': startDate, 'messageDuration.messageStartTime': startTime, 'messageDuration.messageEndDate': endDate, 'messageDuration.messageEndTime': endTime}"
      [pageSizeOptions] = "[5, 10, 15]"
      [buttonConfig]="{
          edit: {show: false},
          delete: {show: false},
          addbtn: {output: 'addbtn', template: addbtn}
      }"
      [objectBluePrint]="{}"
      (buttonClick)="addMessageToGroup($event)">
  </app-mat-data-grid>
</div>

<ng-template #addbtn>
  <mat-icon>add</mat-icon>
</ng-template>

<ng-template #header>
  <mat-icon class="cancel-btn" (click)="showMessageTable = false;">close</mat-icon>
</ng-template>